import { LinkTab, LinkTabs } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

export const UserNavigation: FC = () => {
	const { t } = useTranslation();

	return (
		<>
			<LinkTabs>
				<LinkTab to="edit">{t("Edit")}</LinkTab>
				<LinkTab to="applications">{t("Applications")}</LinkTab>
				<LinkTab to="events">{t("Events")}</LinkTab>
				<LinkTab to="roles">{t("Roles")}</LinkTab>
				<LinkTab to="tenants">{t("Tenants")}</LinkTab>
			</LinkTabs>
			<Outlet />
		</>
	);
};
